export var Paths;

(function (Paths) {
  Paths["ListAutocomplete"] = "/search/autocomplete";
  Paths["GetContentSuggestion"] = "/search/content_suggestions";
  Paths["Search"] = "/search";
})(Paths || (Paths = {}));